import { InvitationFlowStore } from '@coursera-web/groups-invitation';
import Fluxible from 'vendor/cnpm/fluxible.v0-4/index';

/* @ts-expect-error ts-migrate(7016) FIXME: Untyped import */
import Routes from 'pages/groups/routes';

import AuthoringStateStore from 'bundles/author-common/stores/AuthoringStateStore';
import CourseMaterialStore from 'bundles/author-course/stores/CourseMaterialStore';
import ProctorConfigStore from 'bundles/author-course/stores/ProctorConfigStore';
import ItemStateStore from 'bundles/authoring/common/stores/ItemStateStore';
import GroupEventsStore from 'bundles/group-events/stores/GroupEventsStore';
import InvitationStore from 'bundles/groups-common/stores/InvitationStore';
import MemberStore from 'bundles/groups-common/stores/MemberStore';
import DiscussionGradingStore from 'bundles/groups-dashboard-content/stores/DiscussionGradingStore';
import ExportStore from 'bundles/groups/stores/ExportStore';
import GroupAnnouncementStore from 'bundles/groups/stores/GroupAnnouncementStore';
import GroupStore from 'bundles/groups/stores/GroupStore';
import SettingStore from 'bundles/groups/stores/SettingStore';
import NaptimeStore from 'bundles/naptimejs/stores/NaptimeStore';
import ApplicationStore from 'bundles/ssr/stores/ApplicationStore';

import 'css!bundles/global-styles/global-element-styles';

const App = new Fluxible({
  component: Routes,
});

App.registerStore(NaptimeStore);
App.registerStore(ApplicationStore);
App.registerStore(GroupStore);
App.registerStore(ExportStore);
App.registerStore(MemberStore);
App.registerStore(GroupAnnouncementStore);
App.registerStore(GroupEventsStore);
App.registerStore(SettingStore);
App.registerStore(InvitationStore);
App.registerStore(AuthoringStateStore);
App.registerStore(CourseMaterialStore);
App.registerStore(InvitationFlowStore);
App.registerStore(ProctorConfigStore);
App.registerStore(DiscussionGradingStore);
App.registerStore(ItemStateStore);

export default App;
